import { Flex, Typography } from '@aloft/toolkit-sui';

export const UnsupportedDeviceOverride = () => (
  <Flex
    width="80%"
    margin="auto"
    height="100%"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    gap={4}
  >
    <Typography variant="h2" textAlign="center">
      This function of Toolkit is not supported on screen widths smaller than 600 pixels. We
      recommend you use this experience on your desktop or laptop.
    </Typography>
  </Flex>
);
